import { render, staticRenderFns } from "./EditOrgName.vue?vue&type=template&id=0444e72e&scoped=true"
import script from "./EditOrgName.vue?vue&type=script&lang=js"
export * from "./EditOrgName.vue?vue&type=script&lang=js"
import style0 from "./EditOrgName.vue?vue&type=style&index=0&id=0444e72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444e72e",
  null
  
)

export default component.exports